import React from 'react'
import ClaimDetails from './ClaimDetails'

class ClaimItem extends React.Component {

  constructor(props) {
    super(props)

    this.itemLink = `/claims/${props.claim.id}/edit`
    if (['submitted', 'completed', 'failed', 'pending_send'].indexOf(props.claim.status) >= 0) {
      this.itemLink = `/claims/${props.claim.id}`
    } else if (props.claim.status == 'draft') {
      this.itemLink = `/claims/${props.claim.id}/start_claim`
    }
  }

  statusText () {
    switch (this.props.claim.status) {
      case 'draft':
        return 'Get Started'
        break
      case 'processing':
        return 'Resume'
        break
      case 'submitted':
        return 'Request Sent'
        break
      case 'completed':
        return 'Claim Information'
        break
      case 'failed':
        return 'Submission Error'
        break
      case 'pending_send':
        return 'Processing'
        break
      default:
        return 'Get Started'
    }
  }

  buttonBackgroundColor () {
    if (this.props.claim.status == 'submitted') {
      return 'green'
    } else if (this.props.claim.status == 'failed') {
      return '#123F6E'
    } else {
      return 'forestgreen'
    }
  }

  renderCloudIcon () {
    return this.props.claim.status == 'draft' ? (
      <div className="claim-item-icon">
        <i className="material-icons blue-icon">cloud_upload</i>
      </div>
    ) : null
  }

  renderClaimDetails() {
    if (this.props.workflow_unum) {
      return <ClaimDetails claimId={this.props.id} description={this.props.description}/>
    }
  }

  render () {
    const divBackgroundImg = {
      backgroundImage: `url(${this.props.claim.logo_url})`
    }
    const getStartedCss = {
      'backgroundColor': `${this.buttonBackgroundColor()}`
    }
    const { claim } = this.props
    return (
      <div className='col-sm-11 claim-item tasks-counter'>
        <div className='claim-img col-xs-4' style={ divBackgroundImg }></div>
        <div className='claim-item-content col-xs-8'>
          <div className='claim-content'>
            {this.renderCloudIcon()}
            <div className='claim-title'>
              <div className='item-name'>
                <h3> { claim.name } </h3>
              </div>
            </div>
{/*            <div className="claim-item-description" id={`claim-${this.props.id}`}>
              <div className='description' dangerouslySetInnerHTML={{__html: this.props.description}} />
            </div>*/}
            { this.renderClaimDetails() }
          </div>
          <div className="claim-item-button">
            <a
            className='btn btn-dark btn-bdr-rds'
            style={ getStartedCss }
            href={ this.itemLink }
            > {this.statusText()} </a>
          </div>
        </div>
      </div>
    )
  }
}

export default ClaimItem;